import React from 'react';
import styled from 'react-emotion';
import { cx } from 'react-emotion';
import { theme } from '../../Theme';
import useCleanProps from '../../../hooks/useCleanProps';
import MaxWidth from '../../Layout/MaxWidth';

const LineContainer = styled('div')`
  max-width: 60rem;
  border-top: 1px solid ${theme.colors.black};
  width: 100%;
  margin: 0 auto;

  &.indented {
    width: calc(100% - 6rem);
    max-width: calc(60rem - 6rem);
  }

  &.full-width {
    max-width: 100%;
  }

  &.color-accent-color {
    border-color: ${theme.colors.red};
  }

  &.color-light-gray {
    border-color: ${theme.colors.gray[4]};
  }

  &.color-dark-gray {
    border-color: ${theme.colors.gray[2]};
  }
`;

const DividerLine = props => {
  const {
    color = 'Black',
    thickness = '1px',
    fullWidth,
    indented,
    spaceAbove = '16px'
  } = useCleanProps(props);

  if (!props) return null;

  return (
    <MaxWidth style={{ marginTop: spaceAbove }}>
      <LineContainer
        className={cx(
          `color-${color.toLowerCase().replace(' ', '-')}`,
          `${fullWidth ? 'full-width' : ''}`,
          `${indented ? 'indented' : ''}`
        )}
        style={{ borderWidth: thickness }}
      />
    </MaxWidth>
  );
};

export default DividerLine;
